module.exports = __webpack_public_path__ + "static/media/rightbn.98125631.png";